module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_add-to-unscopables.js
// module id = 284
// module chunks = 16